export { default } from 'app/developer-v3/pages/triggers/TriggerEditor/Container';
